import React from 'react'
import ContextMenu from './ContextMenu'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import withProps from 'recompose/withProps'
import { isDevelopment, isLocalDevelopment } from 'aria-viewer/utils/environment'

// TEMP DEV ONLY
const TEMP_THEME =
    isDevelopment() || isLocalDevelopment() ? styleguide.contextMenuDesktop.darkFullLabel : styleguide.contextMenu.dark
const TEMP_WIDTH = isDevelopment() || isLocalDevelopment() ? 'auto' : '3.5em'

const props = withProps(({ isMobile }) => ({
    theme: isMobile ? styleguide.contextMenu.dark : TEMP_THEME,
    width: isMobile ? '4em' : TEMP_WIDTH,
}))

const OverflowContextMenu = ({ options, theme, width }) => (
    <ContextMenu
        style={{
            width,
        }}
        theme={theme}
        options={options}
    />
)

export default compose(props, pure)(OverflowContextMenu)
